import React, { FC, useEffect, useState } from 'react';
import { Subscription } from 'rxjs';
import classnames from 'classnames';

import { unsubscribeComponent } from 'utils/unsubscribeComponent';
import { getSystemOption } from 'api/postitivePay/service';
import { SYSTEM_OPTIONS } from 'constants.js';

import { FDIC_DISCLAIMER_VARIANTS, MAX_DISCLAIMER_LENGTH } from './FdicLogo.constants';
import useStyles from './FdicDisclaimer.styles';
import { OptionType } from './FdicLogo.types';

const { FDIC_INVESTMENT_ACCOUNT_TEXT, FDIC_OTHER_ACCOUNT_TEXT } = SYSTEM_OPTIONS;
const { INVESTMENT, OTHER } = FDIC_DISCLAIMER_VARIANTS;

interface Props {
  type: typeof INVESTMENT | typeof OTHER;
  className?: string;
}

const OPTION_ID_MAP = {
  INVESTMENT: FDIC_OTHER_ACCOUNT_TEXT,
  OTHER: FDIC_INVESTMENT_ACCOUNT_TEXT
};

const subscription: Record<string, Subscription | null> = {
  getSystemOption: null
};

const FdicLogo: FC<Props> = ({ className, type }) => {
  const [fdicDisclaimer, setFdicDisclaimer] = useState<OptionType>();
  const { fdicDisclaimerText } = useStyles();

  useEffect(() => {
    subscription.getSystemOption = getSystemOption({ optId: OPTION_ID_MAP[type] }).subscribe(
      ({ data: disclaimer, success }) => {
        if (success) {
          setFdicDisclaimer(disclaimer);
        }
      }
    );

    return () => unsubscribeComponent(subscription);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!fdicDisclaimer) {
    return <></>;
  }

  return (
    <div data-qa="fdic-disclaimer-container" className={classnames(fdicDisclaimerText, className)}>
      {fdicDisclaimer.slice(0, MAX_DISCLAIMER_LENGTH)}
    </div>
  );
};

export default FdicLogo;
